import { render, staticRenderFns } from "./LearningGroup.vue?vue&type=template&id=b43dca72&"
import script from "./LearningGroup.vue?vue&type=script&lang=ts&"
export * from "./LearningGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports